import { createSelector } from "reselect"

const selectCart = (state) => state.cart

export const selectCartItems = createSelector([selectCart], (cart) => cart.cartItems)

export const selectUserInfo = createSelector([selectCart], (cart) => cart.userInfo)

export const selectPaymentMethod = createSelector([selectCart], (cart) => cart.paymentMethod)

export const selectCartHidden = createSelector([selectCart], (cart) => cart.showDropdown)

export const selectCartItemsCount = createSelector([selectCartItems], (cartItems) =>
  cartItems.reduce((accumulatedCount, cartItem) => accumulatedCount + cartItem.quantity, 0)
)

// export const selectCartTotal = createSelector(
//     [selectCartItems],
//     (cartItems) => cartItems.reduce(
//         (accumulatedCount, cartItem) => accumulatedCount + cartItem.quantity * cartItem.price, 0
//     )
// )

export const selectCartTotal = createSelector([selectCartItems], (cartItems) =>
  cartItems.reduce((accumulatedCount, cartItem) => accumulatedCount + cartItem.quantity * cartItem.cakePrice, 0)
)

export const selectCartTotalWithAddon = createSelector([selectCartItems], (cartItems) =>
  cartItems.reduce(
    (accumulatedCount, cartItem) => accumulatedCount + cartItem.quantity * cartItem.cakePriceWithAddon,
    0
  )
)
